import React from "react";
import { Link } from "react-router-dom";
import enterpriseBG from "../../src/assets/images/enterprise-bg.png";
import signupbg from "../../src/assets/images/sign-up.png"


const EnterpriseSection = ({ user }) => {
  return (
    <section
      id="enterprise"
      className="relative z-10 mx-auto max-w-7xl px-4 pb-20 sm:px-6 lg:px-8"
    >
      <div
        className="relative rounded-3xl p-6 text-center py-16 bg-no-repeat bg-cover bg-top overflow-hidden sm:p-8 sm:py-24 lg:py-32"
        style={{ backgroundImage: `url(${enterpriseBG})` }}
      >
        {/* soft glow overlays */}
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -top-24 left-1/2 h-80 w-80 -translate-x-1/2 rounded-full blur-3xl bg-[#4D80FF]/15" />
          <div className="absolute -bottom-28 right-[-80px] h-96 w-96 rounded-full blur-3xl bg-[#0B3BF0]/18" />
        </div>

        {/* Badge */}
        <div className="reveal reveal-zoom delay-1 mx-auto mb-3 inline-flex items-center justify-center gap-2 rounded-full border border-[#2E2D48] bg-gradient-to-b from-[#0B0A24_80%] to-[#1A39AC] p-3 text-xs uppercase tracking-widest text-[#FFFFFF] relative overflow-hidden">
          {/* badge shimmer */}
          <span className="pointer-events-none absolute inset-0 badge-shimmer opacity-40" />

            <img src={signupbg} alt="logo" />

          <span className="relative z-10">Sign Up</span>
        </div>

        {/* Title */}
        <h2 className="reveal reveal-up delay-2 text-3xl leading-snug text-white font-montserrat tracking-wide sm:text-4xl sm:leading-tight lg:text-5xl">
          <span className="font-semibold">Enterprise</span> <span>RDP</span>{" "}
          <br className="hidden sm:block" />
          Powered by <span className="font-semibold">AMD Ryzen 9 9950X</span>
        </h2>

        {/* Description */}
        <p className="reveal reveal-up delay-3 mx-auto mt-3 max-w-2xl text-sm text-[#9B9DA7] sm:text-base">
          Built on AMD Ryzen 9 9950X processors, our RDP infrastructure delivers
          exceptional speed, stability, and responsiveness. Designed for
          professionals who demand uncompromising performance, security, and
          reliability — without limitations.
        </p>

        {/* CTA */}
        <div className="reveal reveal-zoom delay-4">
          <Link
            to={user ? "/select-plan" : "/signup"}
            className="mt-8 inline-block rounded-xl border border-[#929DB8]/45 bg-gradient-to-r from-[#4D80FF] to-[#0B3BF0] px-9 py-5 text-sm font-semibold text-white shadow-[inset_0_-7px_22px_rgba(255,255,255,0.35)] relative overflow-hidden group transition-all duration-300 hover:-translate-y-1 hover:border-[#B4BDCA]/65 hover:shadow-[inset_0_-7px_22px_rgba(255,255,255,0.35),0_12px_28px_rgba(11,59,240,0.45)]"
          >
            {/* shine effect */}
            <span className="pointer-events-none absolute inset-0 -translate-x-[120%] skew-x-[-20deg] bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-700 ease-out group-hover:translate-x-[120%]" />
            <span className="relative z-10">Get Started</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default EnterpriseSection;